/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-02-09 19:50:35
 * @FilePath: /knit-web/src/router/guard/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { Router } from 'vue-router';
import { setRouteEmitter } from '@/utils/route-listener';
import { useAppStore } from '@/store';
import setupUserLoginInfoGuard from './userLoginInfo';
import setupPermissionGuard from './permission';
import setupEditionGuard from './edition';

/**
 * @msg: 设置路由监听
 * @param {Router} router
 */
function setupPageGuard(router: Router) {
  router.beforeEach(async (to, from) => {
    // emit route change
    setRouteEmitter(to);
    const appStore = useAppStore();
    if (
      [
        'WorkflowDetail',
        'WorkflowExecutionDetail',
        'KnowledgeBaseDetail',
        'KnowledgeDocumentDetail',
      ].includes(to.name as string)
    ) {
      appStore.updateSettings({ menu: false });
    } else {
      appStore.updateSettings({ menu: true });
    }
  });
}

/**
 * @msg: 创建路由及路由守卫
 * @param {Router} router
 */
export default function createRouteGuard(router: Router) {
  setupPageGuard(router);
  setupUserLoginInfoGuard(router);
  setupEditionGuard(router);
  setupPermissionGuard(router);
}
